module.exports = __webpack_public_path__ + "static/media/full_10.5e8f5572.jpg";